import React from "react"
import styles from "./styles.css"
import { Link, withRouter } from "react-router-dom"
import iconArrowRight from "../../../../assets/svg/fixed_voice_navigation_arrow_right.svg"
import iconArrowLeft from "../../../../assets/svg/fixed_voice_arrow_left.svg"
import iconPlus from "../../../../assets/svg/fixed_voice_plus.svg"
import { connect } from "react-redux"
import ButtonFixedVoice from "../ButtonFixedVoice"
import { get } from "lodash"
import PropTypes from "prop-types"

const name = {
  "fixed-voice": "Voz Fixa",
  "new-sale": "Cadastrar venda",
  "specialist-analysis": "Solicitar análise especialista",
  "specialist-requests": "Minhas solicitações ao especialista",
  "confirm-screen": "Cadastrar venda",
  "client-details": "Detalhes do cliente"
}

const BreadcrumbRouter = ({ location, order, hiddenButton = false }) => {
  const paths = location.pathname.split("/").filter((path) => path !== "")
  const confirmPage = paths[paths.length - 1] === "confirm-screen"
  const typeOfResponse = get(order, "typeOfResponse", "")
  const isSpecialist = typeOfResponse === "SPECIALIST"

  return (
    <div className={styles.header}>
      <div className={styles.breadcrumb}>
        {confirmPage ? (
          <div className={styles.confirm_page}>
            <img
              className={styles.arrow_right}
              src={iconArrowLeft}
              alt={"arrow to back"}
            />
            <Link to={"/fixed-voice/"}>Voltar ao início</Link>
          </div>
        ) : (
          <nav>
            <ul>
              {paths.map((path, index) => (
                <li key={index}>
                  <Link to={`/${paths.slice(0, index + 1).join("/")}`}>
                    {index > 0 ? (
                      <div className={styles.breadcrumb_align}>
                        <div className={styles.breadcrumb_center}>
                          <img
                            className={styles.arrow_right}
                            src={iconArrowRight}
                            alt={"down"}
                          />
                        </div>
                        <div className={styles.current_page}>{name[path]}</div>
                      </div>
                    ) : (
                      <div>{name[path]}</div>
                    )}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>
        )}
      </div>
      {confirmPage && !isSpecialist && !hiddenButton && (
        <ButtonFixedVoice
          name={"Cadastrar outra venda"}
          linkName={"new-sale"}
          icon={iconPlus}
          hasBackgroundLink
        />
      )}
    </div>
  )
}

BreadcrumbRouter.propTypes = {
  location: PropTypes.object.isRequired,
  order: PropTypes.object,
  hiddenButton: PropTypes.bool
}

const mapStateToProps = ({ newOrder }) => ({
  order: newOrder.order
})

export default connect(mapStateToProps)(withRouter(BreadcrumbRouter))



// WEBPACK FOOTER //
// ./src/scenes/FixedVoice/components/Breadcrumb/index.js